export interface AppIconMapping {
  name: string;
  icon: string;
}

export const APP_ICON_MAP: AppIconMapping[] = [
  { name: 'Human by Design', icon: 'atom' },
  { name: 'Platform Beheer', icon: 'screwdriver-wrench' }
];

export function resolveAppIcon(appName: string | null | undefined): string | undefined {
  if (!appName) {
    return undefined;
  }

  const needle = appName.trim().toLowerCase();
  return APP_ICON_MAP.find(mapping => mapping.name.toLowerCase() === needle)?.icon;
}
